import WidgetModule from "@eisinc/Overrides/Widgets/SavedOrderDetails/SavedOrderDetailsActionButtons";

export * from "@eisinc/Overrides/Widgets/SavedOrderDetails/SavedOrderDetailsActionButtons";

export default WidgetModule;
